import React from "react"

const Bar = ({ className }) => <span className={`hb-shimmer block rounded ${className}`} />

const DrawerSkeleton = () => (
  <div className="px-6 py-5 flex flex-col gap-6" aria-busy="true">
    <div className="flex gap-6">
      {[0, 1, 2].map(index => (
        <div key={index} className="flex-1 flex flex-col gap-2">
          <span className="hb-shimmer block w-[26px] h-[26px] rounded-full" />
          <Bar className="h-[9px] w-[70px]" />
          <Bar className="h-[7px] w-[90px]" />
        </div>
      ))}
    </div>
    {[0, 1].map(index => (
      <div key={index} className="rounded-lg border border-slate-200 p-3 flex flex-col gap-2.5">
        <Bar className="h-[9px] w-[100px]" />
        <div className="grid grid-cols-2 gap-2"><Bar className="h-[32px]" /><Bar className="h-[32px]" /></div>
        <div className="grid grid-cols-4 gap-2"><Bar className="h-[32px]" /><Bar className="h-[32px]" /><Bar className="h-[32px]" /><Bar className="h-[32px]" /></div>
      </div>
    ))}
    <div className="rounded-lg border border-slate-200 p-4 flex flex-col gap-3">
      {[0, 1, 2].map(index => <Bar key={index} className="h-[26px]" />)}
    </div>
  </div>
)

export default DrawerSkeleton
